import { useEffect, useState } from "react";
import MySelect from "../UI/select/MySelect";
import MyButton from "../UI/button/MyButton";
import { useAxiosPostRefreshing, useAxiosPutRefreshing } from "../../hooks/useAxios";
import { backend_routes } from "../../common/links";

const EventModal = function({legendsMap, event, eventChangingCallback, closeModalCallback, actionMethod}){
    const legends = [];
    for (let mapItem of legendsMap.keys()){
        legends.push({ value: mapItem, name: legendsMap.get(mapItem) });
    }
    const [startDate, setStartDate] = useState(event.start.substring(0, 16));
    const [endDate, setEndDate] = useState(event.finish.substring(0, 16));
    const [code, setCode] = useState(event.code);
    const changeStartDate = function (event) { setStartDate(event.target.value); }
    const changeEndDate = function (event) { setEndDate(event.target.value); }

    const [putEvent, isPutLoading] = useAxiosPutRefreshing(
        function (response) {
            if (response.status === 200){
                eventChangingCallback(response.data.data);
                closeModalCallback(false);
            }
        });

    const [postEvent, isPostLoading] = useAxiosPostRefreshing(
        function (response) {
            if (response.status === 200) {
                eventChangingCallback(response.data.data);
                closeModalCallback(false);
            }
        });
    const sendPost = function(){
        if (code===0){
            alert("Необходимо выбрать тип события");
        }
        else postEvent(backend_routes.EVENTS_POST, request);
    }
    
    const offset = function(){
        let date = new Date();
        let offset = date.getTimezoneOffset();
        let absOffset = Math.abs(offset)
        let offHours = parseInt((absOffset)/60);
        let offMinutes = absOffset-(60*offHours);
        if (Math.abs(offHours)<10) offHours = "0"+offHours;
        if (Math.abs(offMinutes)<10) offMinutes = "0"+offMinutes;
        let outString = offHours+":"+offMinutes;

        if (offset<0) outString = ":00+"+outString;
        else outString = ":00-"+outString;
        return outString;
    }

    const [request, setRequest] = useState({});
    useEffect(() => {
        setRequest(
            {
                Id : event.Id,
                Code : code,
                start: startDate + offset(),
                finish: endDate + offset()
            }
        );
    }
        , [startDate, endDate, code]);

    return(
        <>
            <MySelect style={{ width: "100%" }} options={legends} defaultValue={"Тип события"} value={code} onChange={setCode} />
            <br />
            <br />
            <input style={{width: "100%"}} type="datetime-local" value={startDate} onChange={(event) => changeStartDate(event)} />
            <br />
            <br />
            <input style={{ width: "100%" }}  type="datetime-local" value={endDate} onChange={(event) => changeEndDate(event)} />
            <br/>
            <br />
            {
                actionMethod==="POST"
                    ? <MyButton style={{ width: "100%" }} onClick={sendPost}>Добавить</MyButton>
                    : <MyButton style={{ width: "100%" }} onClick={() => { putEvent(backend_routes.EVENTS_UPDATING, request) }}>Сохранить</MyButton>
            }
        </>
    );
}
export default EventModal;